import React from 'react';

/**
 * Warning shown when decoded data is unavailable (self-custody parity).
 */
export function UnableToDecodeTransactionAlert(): React.ReactElement {
  return (
    <div className="border border-amber-300/70 bg-amber-50 text-amber-900 rounded-md px-3 py-2 text-sm">
      <div className="font-semibold">Transaction cannot be decoded</div>
      <div className="mt-1 text-amber-800">
        This call could not be decoded. The contract may be unverified, use a
        non-standard proxy, or have missing implementation metadata.
      </div>
    </div>
  );
}
